import React from 'react';

import t from '../../../labels/labelling-utils';
import { Color } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { LiveOnSkyType } from '../../../typings/match';
import { makeClassNames } from '../../../utils/styles';
import Text from '../text/text';
import './live-on-sky-badge.scss';

export interface ILiveOnSkyBadge extends IComponent {
  liveOnSky: LiveOnSkyType;
}

const classNames = (propClassName?: string) =>
  makeClassNames({
    LiveOnSkyBadge: ['live-on-sky-badge', propClassName],
  });

const colorMap: Record<LiveOnSkyType, Color> = {
  LIVE: 'blue',
  EXCLUSIVE: 'red-light',
};

const labelMap: Record<LiveOnSkyType, string> = {
  LIVE: t('live-on-sky-badge.live'),
  EXCLUSIVE: t('live-on-sky-badge.exclusive'),
};

const LiveOnSkyBadge = ({ liveOnSky, className, ...textProps }: ILiveOnSkyBadge) => {
  const cn = classNames(className);

  const color = colorMap[liveOnSky];
  const label = labelMap[liveOnSky];

  return (
    <Text className={cn.LiveOnSkyBadge} fontSize="12--14" color={color} {...textProps}>
      {label}
    </Text>
  );
};

export default LiveOnSkyBadge;
